import { c as _c } from "react/compiler-runtime";
import { MiniChips, MiniChipsColorType } from "@website/ui/mini-chips";
import { numberConvert } from "@website/utils/number-convert";
import { ReserveRateHeaderPropertiesTypes } from "@website/widget/reserve-rate/reserve-rate-header/reserve-rate-header.types";
import { useGetColorAndTextRate } from "@website/widget/reserve-rate/reserve-rate-header/reserve-rate.hooks";
import { useRouter } from "next/router";
const limitRateCount = 10_000_000;
export const ReserveRateHeader = t0 => {
  const $ = _c(21);
  const {
    properties
  } = t0;
  const {
    rate,
    rateCount,
    size: t1
  } = properties;
  const size = t1 === undefined ? "large" : t1;
  const router = useRouter();
  const rateInfo = useGetColorAndTextRate(rate);
  const t2 = `flex flex-row items-center gap-4 ${size === "large" ? "xl:min-w-[175px] xl:justify-between" : ""}`;
  let t3;
  if ($[0] !== rate || $[1] !== router.locale) {
    t3 = Number(rate) > 0 && Number(rate) <= 5 && numberConvert(rate, {
      locale: router.locale
    });
    $[0] = rate;
    $[1] = router.locale;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <div className="text-headline-3 md:text-headline-2">{t3}</div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== rate || $[6] !== rateInfo?.color || $[7] !== rateInfo?.text) {
    t5 = Number(rate) > 3.5 && <MiniChips color={rateInfo?.color as MiniChipsColorType} size="medium" text={rateInfo?.text ?? ""} variant="accent" />;
    $[5] = rate;
    $[6] = rateInfo?.color;
    $[7] = rateInfo?.text;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== rateCount || $[10] !== router.locale) {
    t6 = Number(rateCount) < limitRateCount ? numberConvert(rateCount, {
      locale: router.locale
    }) : numberConvert(limitRateCount, {
      locale: router.locale
    });
    $[9] = rateCount;
    $[10] = router.locale;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const count = t6;
  const t7 = `${count} نظر`;
  let t8;
  if ($[12] !== t7) {
    t8 = <div className="text-caption md:text-body-2">{t7}</div>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t8) {
    t9 = <div className="flex flex-col items-start gap-2">{t5}{t8}</div>;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t2 || $[18] !== t4 || $[19] !== t9) {
    t10 = <div className={t2}>{t4}{t9}</div>;
    $[17] = t2;
    $[18] = t4;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};